import type { FC, SVGProps } from 'react';

export const HeyReachLogo: FC<SVGProps<SVGSVGElement>> = ({
  width = 28,
  height = 28,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 92 112"
    preserveAspectRatio="xMidYMid"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <rect
        x="10"
        y="10"
        width="72"
        height="92"
        rx="8"
        fill="#ffffff"
        stroke="#e5e7eb"
        strokeWidth="2"
      />
      <g transform="translate(20, 25)">
        <path
          d="M26 15c-7.18 0-13 5.82-13 13v8c0 2.21 1.79 4 4 4s4-1.79 4-4v-8c0-2.76 2.24-5 5-5s5 2.24 5 5v20c0 2.21 1.79 4 4 4s4-1.79 4-4V28c0-7.18-5.82-13-13-13z"
          fill="#3b82f6"
        />
        <circle cx="26" cy="8" r="6" fill="#3b82f6" />
        <path
          d="M15 45c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h22c1.1 0 2-.9 2-2v-8c0-1.1-.9-2-2-2H15z"
          fill="#60a5fa"
        />
      </g>
    </g>
  </svg>
);
